import * as constants from '../../constants';
import Test from '../../test';
import textButton from '../../shared-ui/text-button';

const height = 620;
const modalWidth = 380;
const bodyHeight = 140;
let currentTest;

export const sprite = new PIXI.Sprite();
sprite.visible = false;
sprite.interactive = true;
sprite.on('pointerdown', e => {
  e.stopPropagation();
});

export const showModal = () => {
  sprite.visible = true;
  sprite.emit('show-hide');
};

Test.eventEmitter.on('TEST_START', test => {
  currentTest = test;
});

const bg = new PIXI.Graphics();
sprite.addChild(bg);
bg.beginFill(0x000000, 0.4).drawRect(0, 0, constants.screenWidth, height).endFill();

const modal = new PIXI.Sprite();
modal.position.set(( constants.screenWidth - modalWidth ) / 2, 100);
sprite.addChild(modal);

const headerBg = new PIXI.Graphics();
modal.addChild(headerBg);
headerBg
.clear()
.beginFill(constants.lightBlue)
.drawRect(0, 0, modalWidth, constants.headerHeight)
.endFill();

const headerText = new PIXI.Text('Are you sure you want to exit?', {
  font: '18px Open Sans, Arial',
  fill: 0xFFFFFF,
  align: 'center',
  letterSpacing: 1
});
modal.addChild(headerText);
headerText.anchor.set(0.5);
headerText.position.set(modalWidth / 2, constants.headerHeight / 2);

const bodyBg = new PIXI.Graphics();
modal.addChild(bodyBg);
bodyBg
.clear()
.beginFill(0xFFFFFF)
.drawRect(0, constants.headerHeight, modalWidth, bodyHeight)
.endFill();

const bodyText = new PIXI.Text('Exiting will finish this quiz and\nsend you back to the main menu.', {
  font: '17px Open Sans, Arial',
  fill: constants.darkestBlue,
  align: 'center',
  letterSpacing: 1
});
modal.addChild(bodyText);
bodyText.anchor.set(0.5, 0);
bodyText.position.set(modalWidth / 2, constants.headerHeight + 20);

const buttons = new PIXI.Sprite();
modal.addChild(buttons);
buttons.anchor.set(0.5, 0);
buttons.position.set(modalWidth / 2, constants.headerHeight + 100);

const buttonWidth = 150;
const buttonSpacing = 20;
const cancelExitBtn = textButton({ text: 'CONTINUE QUIZ', bgColour: constants.darkestBlue, width: buttonWidth });
const confirmExitBtn = textButton({ text: 'EXIT QUIZ', bgColour: constants.red, width: buttonWidth });
buttons.addChild(cancelExitBtn);
buttons.addChild(confirmExitBtn);
cancelExitBtn.x = -( buttonWidth + buttonSpacing) / 2;
confirmExitBtn.x = ( buttonWidth + buttonSpacing) / 2;

cancelExitBtn.on('pointerdown', () => {
  sprite.visible = false;
  sprite.emit('show-hide');
});
confirmExitBtn.on('pointerdown', () => {
  sprite.visible = false;
  currentTest.end();
});
